export default class BaseApi {
  constructor($axios) {
    this.$axios = $axios
  }
}
